export const EmailFilterWarmupErrorsIcon = ({ color = "#28287B" }) => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 7.35669C6 6.42062 4.73667 6.1725 4.4015 7.04836C3.59074 9.16702 3 11.0623 3 12.087C3 15.3527 5.68629 18 9 18C12.3137 18 15 15.3527 15 12.087C15 10.9861 14.3181 8.88032 13.4141 6.57226C12.2431 3.58242 11.6576 2.0875 10.9348 2.00698C10.7035 1.98121 10.4512 2.02754 10.2449 2.13365C9.6 2.46526 9.6 4.09574 9.6 7.35669C9.6 8.33639 8.79411 9.13059 7.8 9.13059C6.80589 9.13059 6 8.33639 6 7.35669Z"
          stroke={color}
          strokeWidth="2"
        />
        <path
          d="M19 18.4856V14M19 21.8103V21.8497"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
